import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function ProductShowcase() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <section className="bg-cream py-24 md:py-36" data-testid="product-showcase">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">The Collection</span>
            <h2 className="mt-5 font-serif text-4xl md:text-6xl leading-[0.95] text-obsidian">
              Three formulas.<br /><span className="italic">Every concern.</span>
            </h2>
          </div>
          <Link to="/shop" className="group inline-flex items-center gap-2 font-sans uppercase tracking-[0.2em] text-xs text-obsidian hover:text-amber-deep transition-colors">
            View full shop
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
